import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL + '/bl'; // Remove /api prefix

export const createBonliv = (bonlivData) => axios.post(`${API_BASE_URL}/createbl`, bonlivData);

export const validateBonliv = (refBonliv) => axios.post(`${API_BASE_URL}/validatebl/${refBonliv}`);

export const getBonlivById = (id) => axios.get(`${API_BASE_URL}/getbl/${id}`);

export const updateBonliv = (id, bonlivData) => axios.put(`${API_BASE_URL}/updatebl/${id}`, bonlivData);

export const deleteBonliv = (id) => axios.delete(`${API_BASE_URL}/deletebl/${id}`);

export const getAllBonliv = (params) => 
  axios.get(`${API_BASE_URL}/getallbl`, { params });

export const getBonlivByClient = (clientId) => axios.get(`${API_BASE_URL}/getbonliv/client/${clientId}`);

export const getBonlivByCommercial = (commercialId) => axios.get(`${API_BASE_URL}/getbonliv/commercial/${commercialId}`);

export const addItemToBonliv = (refBonliv, itemData) => axios.post(`${API_BASE_URL}/additem/${refBonliv}`, itemData);

export const deleteItemFromBonliv = (refBonliv, codeArt) => axios.delete(`${API_BASE_URL}/deleteitem/${refBonliv}/${codeArt}`);

export const updateItemInBonliv = (refBonliv, codeArt, itemData) => axios.put(`${API_BASE_URL}/updateitem/${refBonliv}/${codeArt}`, itemData);

export const getItemsInBonliv = (refBonliv) => axios.get(`${API_BASE_URL}/getallitems/${refBonliv}`);

export const bulkUpdateItemsInBonliv = (updates) => {
  return axios.post(`${API_BASE_URL}/bulkupdateitems`, updates);
};

export const updateBonlivStatus = (refBonliv, newStatus) => axios.put(`${API_BASE_URL}/status/${refBonliv}`, { newStatus });

export const saveBonliv = (data) => axios.post(`${API_BASE_URL}/save`, data);

export const unvalidateBonliv = (id) => axios.post(`${API_BASE_URL}/unvalidate/${id}`);

export const getBonlivPerEtage = (refBL) => axios.get(`${API_BASE_URL}/getblperetage/${refBL}`);

export const getAllBonlivPerEtageOverview = (params) => axios.get(`${API_BASE_URL}/getallpreparationoverview`, { params });

export const getPreparationOverviewGrouped = (params) =>
  axios.get(`${API_BASE_URL}/getpreparationoverview-grouped`, { params });

export const markBonlivPerEtagePrinted = (payload) =>
  axios.post(`${API_BASE_URL}/bonliv-per-etage/mark-printed`, payload);

// New functions for etage filtering

/**
 * Get all available etages (floors) from BonlivPerEtage
 * @returns {Promise} Promise resolving to response with etages array
 */
export const getAvailableEtages = () => axios.get(`${API_BASE_URL}/available-etages`);

/**
 * Get all items for a specific bonliv and etage combination
 * @param {number} bonlivId - Bonliv ID
 * @param {number} etage - Floor number
 * @returns {Promise} Promise resolving to response with items array
 */
export const getBonlivItemsByEtage = (bonlivId, etage) => 
  axios.get(`${API_BASE_URL}/bonliv/${bonlivId}/etage/${etage}/items`);

export const transferBonlivToGroupe = (id) => axios.post(`${API_BASE_URL}/transfertogroupe/${id}`);

export const getAllBonlivForCollection = (params) => 
  axios.get(`${API_BASE_URL}/collection`, { params });

/**
 * Recreate BonlivPerEtage records for all BonLivs in EN_PREPARATION status
 * @returns {Promise} Promise resolving to response with results
 */
export const recreateBonlivPerEtageForAll = () => 
  axios.post(`${API_BASE_URL}/recreate-bonliv-per-etage/all`);

/**
 * Recreate BonlivPerEtage records for a specific BonLiv
 * @param {string|number} identifier - BonLiv ID or REF_BL
 * @returns {Promise} Promise resolving to response with results
 */
export const recreateBonlivPerEtageForOne = (identifier) => 
  axios.post(`${API_BASE_URL}/recreate-bonliv-per-etage/${identifier}`);

// Note: getAllBonlivPerEtageOverview already accepts params, so entrepot will be passed through automatically

// Seed DBF upload APIs
export const uploadBonlivDBF = (formData) =>
  axios.post(`${API_BASE_URL}/seed/upload-bonliv`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

export const uploadBonlivDetailsDBF = (formData) =>
  axios.post(`${API_BASE_URL}/seed/upload-details`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

export const uploadBothBonlivDBF = (formData) =>
  axios.post(`${API_BASE_URL}/seed/upload-both`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });